import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { FunctionComponent } from "react";
import { IProps } from "./error-fallback.types";
import "./error-fallback.scss";

/**
 * Show the user a message when the app crashes.
 * @param variant - What the user is being told about. `crash` is an application error, which is worth reporting;
 * `assetLoad` is a file that failed to load, which is usually transient and worth retrying instead.
 * @returns The crash message, or retry guidance when a file merely failed to load.
 */
const ErrorFallback: FunctionComponent<IProps> = ({ variant = "crash" }) => {
    if (variant === "assetLoad") {
        return (
            <Page>
                <PageHeader title="Could not load WatchTower" />
                <PageContent>
                    <div className="error-fallback">
                        Part of WatchTower could not be loaded. This is usually a temporary network or caching problem
                        rather than a fault in WatchTower. Please reload the page to try again or, if the problem
                        persists, email info+error@edgetier.com.
                    </div>
                </PageContent>
            </Page>
        );
    }

    return (
        <Page>
            <PageHeader title="Error" />
            <PageContent>
                <div className="error-fallback">
                    Unfortunately, WatchTower has crashed. Please refresh the page to try again or, if the problem
                    persists, email info+error@edgetier.com.
                </div>
            </PageContent>
        </Page>
    );
};

export default ErrorFallback;
